import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-800 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h4 className="font-heading text-lg font-bold text-white mb-4">
              <Link to="/" className="hover:text-primary-400 transition-colors cursor-pointer">亚洲天堂</Link>
            </h4>
            <p className="text-sm text-background-400 leading-relaxed">
              亚洲天堂汇聚东南亚、东亚及南亚最令人心动的旅游目的地，从碧海白沙到千年古迹，从热带雨林到都市繁华，为您打造一站式梦幻旅行体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">
              热门目的地
            </h4>
            <ul className="space-y-2.5">
              {categories.map(cat => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/category/southeast-asia" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  查看全部
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/category/southeast-asia" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">旅行攻略</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">
              联系我们
            </h4>
            <ul className="space-y-2.5 text-sm text-background-400">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-primary-400"></i>
                <span>contact@asiaparadise.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line mt-0.5 text-primary-400"></i>
                <span>+86 400-888-9999</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-primary-400"></i>
                <span>上海市浦东新区陆家嘴金融区</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700/50 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 亚洲天堂 Asia Paradise. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-background-400 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-background-400 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-background-400 hover:text-primary-400 transition-colors cursor-pointer" aria-label="小红书">
              <i className="ri-red-packet-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}